import { c as _c } from "react/compiler-runtime";
import { HStack, Icon, RadioCard, SimpleGrid, Text } from '@chakra-ui/react';
import type { CrmPalette } from '@src/components/sco/Admin/AiCrm/crmLane';
import React, { type ReactNode } from 'react';
import type { IconType } from 'react-icons';
export type ChoiceItem<T extends string> = {
  disabled?: boolean;
  hint?: ReactNode;
  icon?: IconType;
  label: ReactNode;
  palette?: CrmPalette;
  value: T;
};

/**
 * "Send it to" and "Kind of card": a row of selectable tiles. Built on RadioCard, so it is
 * one radio group to a keyboard and a screen reader. The selected tile takes its own palette.
 */
export function ChoiceTiles(props) {
  const $ = _c(18);
  const columns = props.columns || props.items.length;
  const t0 = props.ariaLabel;
  const t1 = props.disabled;
  const t2 = props.value;
  let t3;
  if ($[0] !== props) {
    t3 = event => {
      if (event.value) {
        props.onChange(event.value as T);
      }
    };
    $[0] = props;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== columns) {
    t4 = {
      base: 2,
      md: columns
    };
    $[2] = columns;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== props.items || $[5] !== props.value) {
    let t6;
    if ($[7] !== props.value) {
      t6 = item => <RadioCard.Item key={item.value} colorPalette={item.value === props.value ? item.palette || "gray" : "gray"} disabled={item.disabled} value={item.value}><RadioCard.ItemHiddenInput /><RadioCard.ItemControl><RadioCard.ItemContent><HStack gap={1.5}>{item.icon ? <Icon color="colorPalette.fg" size="sm"><item.icon /></Icon> : null}<RadioCard.ItemText fontWeight="bold">{item.label}</RadioCard.ItemText></HStack>{item.hint ? <Text color="fg.muted" fontSize="xs">{item.hint}</Text> : null}</RadioCard.ItemContent></RadioCard.ItemControl></RadioCard.Item>;
      $[7] = props.value;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t5 = props.items.map(t6);
    $[4] = props.items;
    $[5] = props.value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <SimpleGrid columns={t4} gap={2}>{t5}</SimpleGrid>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props.ariaLabel || $[13] !== props.disabled || $[14] !== props.value || $[15] !== t3 || $[16] !== t6) {
    t7 = <RadioCard.Root aria-label={t0} disabled={t1} size="sm" value={t2} variant="outline" onValueChange={t3}>{t6}</RadioCard.Root>;
    $[12] = props.ariaLabel;
    $[13] = props.disabled;
    $[14] = props.value;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}